import { Order } from 'storeTypes'

type GetOwnedPackageCountArgs = {
    fullGoalItems: Order[]
}

/**
 * Count fulfilled, non-dropped rows for packageId (warehouse delivered or
 * VE hands). Undelivered rows stay out of owned — cartQty holds those.
 */
export const getOwnedPackageCount = (
    packageId: string,
    { fullGoalItems }: GetOwnedPackageCountArgs
): number => {
    if (!packageId || !fullGoalItems?.length) {
        return 0
    }

    return fullGoalItems.filter(
        (order) =>
            order.package_id === packageId &&
            (order.delivered === true || order.ve_delivered === true) &&
            order.dropped !== true
    ).length
}
